module.exports = __webpack_public_path__ + "img/adecco.ef9bbd48.png";